module.exports = __webpack_public_path__ + "static/media/iconPetsPosted.a60e32a7.svg";